import { useCallback, useEffect, useState } from 'react';
import { useAppContext } from '../../app/Context';
import { useEventListener } from '../../utils/hooks';

const useNavigationNotification = () => {
  const { isPresenting } = useAppContext();

  const [isInFocus, setIsInFocus] = useState(false);

  const handleBlur = useCallback(() => {
    if (!isPresenting) return;
    setIsInFocus(false);
  }, [isPresenting]);

  useEventListener('blur', handleBlur);

  const handleFocus = useCallback(() => {
    if (!isPresenting) return;
    setIsInFocus(true);
  }, [isPresenting]);

  useEventListener('focus', handleFocus);

  return { isPresenting, isInFocus };
};

export default useNavigationNotification;
